import React from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

const SettingsMain = ({ activeSettingsTab, setActiveSettingsTab }) => {
  const settingsMenu = [
    {
      id: 'general',
      name: 'General Settings',
      description: 'Application preferences and configuration',
      icon: Cog6ToothIcon
    }
  ];

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-600 mt-2">Manage your application settings</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {settingsMenu.map((setting) => {
            const Icon = setting.icon;
            return (
              <button
                key={setting.id}
                onClick={() => setActiveSettingsTab(setting.id)}
                className="p-6 bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 text-left"
              >
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-blue-50 rounded-lg">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {setting.name}
                    </h3>
                    <p className="text-gray-600">
                      {setting.description}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SettingsMain;
